// React
import React from 'react';


// COMPONENTS

import PText from 'components/Primatives/PText';
import FlexColumn from 'components/Primatives/FlexColumn';
import FlexRow from 'components/Primatives/FlexRow';
import StyledRouteLink from 'components/Assests/StyledRouteLink';
import GlobalMaxWidth from 'components/Assests/GlobalMaxWidth';
import Strong from 'components/TextModifiers/Strong';

// UTILS
import { constants } from '../../constants';

/*

Props:

*/

const CompanyBreadcrumbs = (props) => {
    const spacing = 10;
    const fontSize = '1.3em';
    const textColor = constants.color.primaryDark;
    const styles = {
        shardStyles : {
            marginRight: spacing, 
            fontSize: fontSize, 
            marginTop: 0, 
            marginBottom: 0,
            color: textColor,
            padding: '5px 0'
        }
    }

    let companyRoles = props.companyRoles;
    // console.log('companyRoles', companyRoles)
    // console.log('companyRoles.accountAdmin', companyRoles.accountAdmin)
    
    return (
        <GlobalMaxWidth style={{backgroundColor: 'rgb(230, 230, 230)', width:'100%', alignSelf: 'center', maxWidth: 'none', paddingLeft: '4vw', paddingRight: '2vw'}}>
            <FlexRow style={{ flex: 'none', width: '100%', alignItems: 'baseline' }}>
                { !(companyRoles.accountAdmin || companyRoles.staffAdmin) &&
                    <StyledRouteLink style={{ ...styles.shardStyles}}
                        to={`/`}
                    >
                        Client List
                    </StyledRouteLink>
                }
                { (companyRoles.accountAdmin || companyRoles.staffAdmin) &&
                    <StyledRouteLink style={{ ...styles.shardStyles}}
                        to={`/company/dashboard`}
                    >
                        Company Dashboard
                    </StyledRouteLink>
                }
                { props.employeeId && 
                    <React.Fragment>
                        { (companyRoles.accountAdmin || companyRoles.staffAdmin) &&
                            <PText style={{ ...styles.shardStyles}}> > </PText>
                        }
                        { (props.location === `/provider/dashboard/${props.employeeId}`) &&
                            <PText style={{ ...styles.shardStyles, color: constants.color.grey54}}> Employee Dashboard </PText>
                        }
                        { (props.location !== `/provider/dashboard/${props.employeeId}`) &&
                        <StyledRouteLink style={{ ...styles.shardStyles}}
                            to={`/provider/dashboard/${props.employeeId}`}
                        >
                            Employee Dashboard
                        </StyledRouteLink>
                        }
                        { (props.path === `/company/employeeEditor`) &&
                            <React.Fragment>
                                <PText style={{ ...styles.shardStyles}}> > </PText>
                                <PText style={{ ...styles.shardStyles, color: constants.color.grey54}}> Employee Editor </PText>
                            </React.Fragment>
                        }
                    </React.Fragment>
                }
                { (props.path === `/company/serviceEditor`) &&
                    <React.Fragment>
                        <PText style={{ ...styles.shardStyles}}> > </PText>
                        <PText style={{ ...styles.shardStyles, color: constants.color.grey54}}> Service Editor </PText>
                    </React.Fragment>
                }
                
            </FlexRow>
        </GlobalMaxWidth>
    )
}




export default CompanyBreadcrumbs;



// WEBPACK FOOTER //
// ./src/js/components/Assests/CompanyBreadcrumbs.jsx